import { render, staticRenderFns } from "./audio-record.vue?vue&type=template&id=6f53d1e5&scoped=true&"
import script from "./audio-record.vue?vue&type=script&lang=js&"
export * from "./audio-record.vue?vue&type=script&lang=js&"
import style0 from "./audio-record.vue?vue&type=style&index=0&id=6f53d1e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f53d1e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f53d1e5')) {
      api.createRecord('6f53d1e5', component.options)
    } else {
      api.reload('6f53d1e5', component.options)
    }
    module.hot.accept("./audio-record.vue?vue&type=template&id=6f53d1e5&scoped=true&", function () {
      api.rerender('6f53d1e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chatLog/lib/audio-record.vue"
export default component.exports